export default {
  'leaderboard.title': '🏆 Referral Leaderboard',
  'leaderboard.subtitle': 'Top referrers',
  'leaderboard.headerTitle': 'Leaderboard',
  'leaderboard.rank': 'Rank',
  'leaderboard.walletAddress': 'Wallet Address',
  'leaderboard.totalReferrals': 'Total Referrals',
  'leaderboard.telegram': 'Telegram',
  'leaderboard.referralCode': 'Referral Code',
  'leaderboard.survey': 'Survey',
  'leaderboard.status': 'Status',
  'leaderboard.createdAt': 'Created At',
  'leaderboard.from': 'From Date',
  'leaderboard.to': 'To Date',
  'leaderboard.copySuccess': 'Copied to clipboard!',
  'leaderboard.notLinked': 'Not Linked',
  'leaderboard.viewDetail': 'View Detail',
  'leaderboard.verified': 'Verified',
  'leaderboard.placeholder.telegram': 'Search by username, name or email (X, Tele, Gmail)',
  'leaderboard.placeholder.code': 'Enter referral code',
  'leaderboard.survey.done': 'Completed',
  'leaderboard.survey.notDone': 'Not Completed',
  'leaderboard.status.verified': 'Verified',
  'leaderboard.status.notVerified': 'Unverified',
  'leaderboard.totalCount': 'Total {total} users',
  'leaderboard.referrals.new': 'New: {count} referrals',
  'leaderboard.referrals.old': 'Old: {count} referrals',
};
